import {makeSplitPoint} from 'plugins/react'

export const UploadInput = makeSplitPoint(() => import('./react/UploadInput'))
export const UploadZoneInput = makeSplitPoint(
	() => import('./react/UploadZoneInput')
)
